import PropTypes from 'prop-types';
import {useCallback} from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import {FixedSizeList} from 'react-window';
import {Grid, Header, Container} from 'semantic-ui-react';

import {useWindowWidth} from 'hooks/useWindowWidth';

import SearchResult from '../SearchResult/SearchResult';
import {highlightText} from '../utils';

import styles from './SearchTable.module.scss';

const SearchTable = ({sites, query}) => {
  // To provide a responsive, usable interface
  const screenWidth = useWindowWidth();
  const rowHeight = useCallback(() => {
    if (screenWidth < 769) {
      return 600;
    } else if (screenWidth < 1024) {
      return 180;
    } else if (screenWidth < 1296) {
      return 140;
    } else if (screenWidth < 1536) {
      return 120;
    } else {
      return 100;
    }
  }, [screenWidth]);

  const SiteRow = ({index, style}) => (
    <div className={styles.ListItem} style={style}>
      <SearchResult
        site={sites[index]}
        highlight={value => {
          return highlightText(value, query);
        }}
      />
    </div>
  );

  SiteRow.propTypes = {
    index: PropTypes.number,
    style: PropTypes.object,
  };

  return (
    <Container className={styles.SearchTable}>
      <Header as="h4" color="grey">
        {sites.length} matching sites
      </Header>
      <Grid columns={7} stackable>
        <Grid.Row className={styles.HeaderRow} verticalAlign="middle" textAlign="center">
          <Grid.Column width={4}>URL</Grid.Column>
          <Grid.Column width={2}>Type</Grid.Column>
          <Grid.Column width={2}>Category</Grid.Column>
          <Grid.Column width={2}>Owner</Grid.Column>
          <Grid.Column width={2}>Admin group</Grid.Column>
          <Grid.Column width={3}>Information</Grid.Column>
          <Grid.Column width={1} />
        </Grid.Row>
        <Grid.Row className={styles.Results}>
          <AutoSizer>
            {({height, width}) => (
              <FixedSizeList
                width={width}
                height={height}
                itemCount={sites.length}
                itemSize={rowHeight()}
              >
                {SiteRow}
              </FixedSizeList>
            )}
          </AutoSizer>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

SearchTable.propTypes = {
  sites: PropTypes.array.isRequired,
  query: PropTypes.string,
};

export default SearchTable;
